<template>
  <div class="root">
    <div class="left">
      <img style="border-radius: 10px;" :src="deail.resourcesUrl" alt="">
      <div class="text">
        <span>{{deail.deviceName}}</span>
        <span>序列号/IMEI：{{ deail.serialNo }}</span>
      </div>
    </div>
    <div class="right">
      <div style="margin-left: 20px;">
        <div class="box">
          <div>
            <span>项目名称：</span>
            <span>{{ deail.name }}</span>
          </div>
          <div>
            <span>所在地：</span>
            <span style="margin-left: 13px;">{{ deail.areaAddress }}</span>
          </div>
          <div>
            <span>项目详址：</span>
            <span>{{ deail.address }}</span>
          </div>
        </div>
        <div class="one">
          <div class="title">
            安装位置区域
            <div style="width: 83px;" class="line"></div>
          </div>
          <hr color="#f2f2f2" style="margin-bottom: 15px;">
          
          <div class="text">
            <div>
              <span>位置区域：</span>
              <span>{{ deail.spaceName }}</span>
            </div>
            <div>
              <span>安装人员：</span>
              <span>{{ deail.installer==null || deail.installer==undefined?'':deail.installer+" ("+deail.installerPhone+")" }}</span>
            </div>
            <div>
              <span>安装时间：</span>
              <span>{{ deail.bindingTime }}</span>
            </div>
          </div>
        </div>
        <div class="two">
          <div class="title">安装前拍照
            <div style="width: 70px;" class="line"></div>
          <hr color="#f2f2f2" style="margin-bottom: 15px;">
          <el-image
              v-for="(item,index) in deail.uninstallImg"
              :key="index"
              style="width: 100px; height: 100px;border-radius: 10px;margin: 10px;"
              :src="item" 
              :preview-src-list="deail.uninstallImg">
            </el-image>
          </div>
        </div>
        <div class="three">
          <div class="title">安装完成拍照
            <div style="width: 83px;" class="line"></div>
          </div>
          <hr color="#f2f2f2" style="margin-bottom: 15px;">
          <el-image
              v-for="(item,index) in deail.installedImg"
              :key="index"
              style="width: 100px; height: 100px;border-radius: 10px;margin: 10px;"
              :src="item" 
              :preview-src-list="deail.installedImg">
            </el-image>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    edit:{
      type:Object,
      default:()=>{}
    },
    deail:{
      type:Object,
      default:() => {}
    },
  },
  data(){
    return {
      listImg:[
        'https://img.paulzzh.com/touhou/random',
        'https://img.paulzzh.com/touhou/random',
        'https://img.paulzzh.com/touhou/random'
      ],
    }
  },
  mounted() {
    console.log("详情",this.deail)
  },
  methods:{
  }
}
</script>

<style lang="scss" scoped>
.root{
  display: flex;
  .left,.right{
    width: 100%;
    height: 500px;
  }
  .left{
    flex: 1;
    // background-color: antiquewhite;
    img{
      width:100%;
      height: 170px;
    }
    .text{
      display: flex;
      flex-direction: column;
      span:nth-child(1){
        color:#0e6ecf;
        font-weight: bold;
        font-size: 19px;
      }
      span:nth-child(2){
        margin-top: 15px;
        color: #c4c4c4;
      }
    }
  }
  .right{
    flex: 2;
    font-size: 13px;
    // background-color: aqua;
    .box{
      div{
        margin-bottom: 15px;
      }
    }
    .one{
      .text{
        div{
          margin-bottom: 15px;
        }
      }
    }
    .line{
      background: #0099ff;
      height: 3px;
    }
    .title{
      display:inline;
      width: 80px;
    }
  }
}

</style>